import { render, staticRenderFns } from "./ContactInfo2.vue?vue&type=template&id=44ba8ea8&scoped=true&"
import script from "./ContactInfo2.vue?vue&type=script&lang=js&"
export * from "./ContactInfo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ba8ea8",
  null
  
)

export default component.exports